var _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 22,
    viewBox: "0 0 22 22",
    width: 22,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    height: 20,
    rx: 3,
    stroke: "#e0e0e0",
    strokeWidth: 2,
    width: 20,
    x: 1,
    y: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckDefault);
export default __webpack_public_path__ + "static/media/check-default.1b330720b1fd3d3529fc10d0f9c6ec99.svg";
export { ForwardRef as ReactComponent };